import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';

import { RestfulService } from '@app/service/restful.service';

@Injectable({
  providedIn: 'root'
})

export class MemberService {

  public memberInfo: any;

  constructor(
    private restful: RestfulService
  ) {
  }

  private extractData(res: Response) {
    let body = res;
    return body || [ ];
  }

  private handleErrorPromise(error: Response | any) {
    console.log(error.message || error);
    return Promise.reject(error.message || error);
  }

  // 로그인정보 가져오기
  getMemberInfo(): Promise<any> {
    return this.restful.get({
        program: 'fms',
        service: 'member',
        version: '1.0',
        action: 'getMember'
      }, {
      }
    ).then( response => {
      if( response.ResultCode )
        this.memberInfo = response.data[0];
      else
        this.memberInfo = [];

      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

  // 로그인
  login(id: string, pw: any): Promise<any> {
    return this.restful.post({
        program: 'fms',
        service: 'member',
        version: '1.0',
        action: 'login'
      }, {
        id:id,
        pw:pw
      }
    ).then( response => {
      return response || [];
    })
     .catch(this.handleErrorPromise);
  }

  // 지역담당자 가져오기
  getMemberSelection(): Promise<any> {
    return this.restful.get({
        program: 'fms',
        service: 'member',
        version: '1.0',
        action: 'getMemberSelect'
      }, {
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 직원리스트 가져오기
  getMemberSelect(): Promise<any> {
    return this.restful.get({
        program: 'fms',
        service: 'member',
        version: '1.0',
        action: 'getMemberSelect'
      }, {
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 접수화면 검사원리스트 가져오기
  getMemberSelectReseption(): Promise<any> {
    return this.restful.get({
        program: 'fms',
        service: 'member',
        version: '1.0',
        action: 'getMemberSelectReseption'
      }, {
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

  // 담당자사무소코드 가져오기
  getMemberOffice(): Promise<any> {
    return this.restful.get({
        program: 'fms',
        service: 'member',
        version: '1.0',
        action: 'getMemberOffice'
      }, {
      }
    ).then(this.extractData)
     .catch(this.handleErrorPromise);
  }

}
